export const ProtectionType = {
  PROTECT_IP: "PROTECT_IP",
  HANDLE_IP: "HANDLE_IP",
  REFERRAL: "REFERRAL",
  ASSISTANCE: "ASSISTANCE",
}